import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * TODO
 */
export const cacheDelete = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    feature.actions.delete.success
      .observe()
      .pipe(
        rxjs.map(action =>
          plugin.collection.plugins.cachePlugin.feature.actions.remove
            .from(action)
            .create({ ids: action.data.request.ids }),
        ),
      ),
)
